<div class="dz-col-xl-24 dz-col-lg-24 dz-col-md-24 margin-object-0 filter-class">
	<p [dcrHTMLKey]="'FILTERNAME_' + filter.meFilterId" class="dz-text-12-condensed-bold filter-header">{{ filter.meFilterId }}</p>
	<button class="dropdown-toggle padding-top-object-2 dz-flex" (click)="showDropdownFilter()">
		<span class="dz-flex dz-justify-content-left" [ngClass]="{ 'selected-filter': selectedFilter.options.length >= 1 }">{{ displayText }}</span>
		<dz-icon class="dropdown-icon dz-flex dz-justify-content-right padding-object-1" type="chevron-down"></dz-icon>
	</button>
	<dz-inline-alert *ngIf="showMobileFilterErrorMsg" type="error" category="module">
		<div dcrHTMLKey="MOBILE_FILTER_ERROR_MSG">Please switch to desktop version to select</div>
	</dz-inline-alert>
	<div class="dropdown-show" *ngIf="showDropDown" role="listbox" aria-multiselectable="true">
		<label *ngFor="let option of filter.options" class="dz-flex dz-flex-sm padding-object-2 dz-align-items-center dz-align-items-center-sm">
			<dz-checkbox [disabled]="false" [(ngModel)]="option.selected" (change)="onFilterSelection(option)"></dz-checkbox>
			<span class="dz-text-16 dz-inline-block dz-inline-block-sm" [dcrHTMLKey]="filter?.id + '_' + option.optionId">{{ option.optionId }}</span>
		</label>
	</div>
</div>
